import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { HeaderBlockSlice } from '../../../../types';
import * as S from './styles';

type Props = Pick<
  HeaderBlockSlice,
  'id' | 'title' | 'description' | 'pagination'
>;

function HeaderBlock({ title, description, pagination }: Props) {
  const { t } = useAppContext();
  const titleWithPagination =
    pagination && pagination.currentPage > 1
      ? t('category', 'product-collection.paginated-title', {
          ...pagination,
          title,
        })
      : title;

  return (
    <S.Header>
      <S.Title>{titleWithPagination}</S.Title>
    </S.Header>
  );
}

export default HeaderBlock;
